// @charset "utf-8";
const tagStyle = {
    request: '#3b73af',
    success: '#67c23a',
    error: 'red'
}

const log = ({ tag = 'request', apiName, description }) => [
    `%c${tag.toUpperCase()}%c 客户端接口：%c${apiName}%c(${description || '请提示开发人员添加接口描述'})`,
    `background:${tagStyle[tag]};color: white; padding: 0 0.5em; border-radius: 2px;`,
    'color: #333; font-weight: 400;',
    'color: #3b73af;',
    'color: #333; font-weight: 400;'
]

function recordLog ({ id, tag = 'request', data, apiName, description }) {
    const log = `${id}:[${tag.toUpperCase()}] ${apiName}(${description}) ${tag === 'error' ? JSON.stringify(data) : ''}`
    window.page.WriteLog('cef_account.log', log)
}

export function logRequest ({ id, apiName, params, description }) {
    console.groupCollapsed(...log({ apiName, description }))
    console.log('参数：', params)
    console.groupEnd()
    if (apiName === 'facade.QueryBrokerInfo') {
        recordLog({ id, data: params, description, apiName })
    }
}

export function transformResponse ({ id, res, apiName, params, description }) {
    const fail = res && res.error !== undefined
    const tag = fail ? 'error' : 'success'
    console.groupCollapsed(...log({ tag, apiName, description }))
    console.log('参数：', params)
    console.log('返回：', res)
    console.groupEnd()
    if (apiName === 'facade.QueryBrokerInfo') {
        recordLog({ id, tag, data: res, description, apiName })
    }
    return {
        status: !fail,
        result: [res && res.result !== undefined ? res.result : res, res],
        error: res && res.error && res.error.message ? res.error : { ...(res && res.error ? res.error : {}), ...res }
    }
}

export function loadCefEnd () {
    return new Promise(resolve => {
        if (window.cef) {
            resolve()
        } else {
            setTimeout(async () => {
                await this.loadCefEnd()
                resolve()
            }, 500)
        }
    })
}



// WEBPACK FOOTER //
// ./src/api/utils.js